import React from 'react';
export default function RadioButton({ bg, label, checked, onChange }) {
  return (
    <label className="radio-cont">
      <input type="radio" checked={checked} onChange={onChange} />
      <span className={`amount ${bg}`}>{label}</span>
    </label>
  );
}
